import {
    InputType,
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { TareaFitoModel } from 'src/app/models/tareas/tarea-fito.model';
import { environment } from 'src/environments/environment';

export class CostesFitosanitariosFormDefinition {
    public formType!: FormType;

    public formFields!: Form<TareaFitoModel>;

    public fieldNames: FormField<TareaFitoModel>[] = [];

    public fieldLabels: string[] = [];

    constructor(type: FormType = FormType.INFORMATIVE) {
        this.formType = +type;

        this.formFields = {
            name: 'costes-fitosanitarios',
            header: 'Detalle del registro',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFormSections(): FormSection<TareaFitoModel>[] {
        return [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getMainFields(),
                order: 1,
            },
        ];
    }

    private getMainFields(): FormField<TareaFitoModel>[] {
        const fields: FormField<TareaFitoModel>[] = [
            this.textField('finca', environment.features.fincaName, 1),
            this.textField('sectores_nombres', 'Sector', 2),
            this.textField('parcelas_nombres', 'Parcela', 3),
            this.textField('fecha_fin', 'Fecha', 4),
            this.textField('tratamiento_nombre', 'Tratamientos', 5),
            this.textField('maquinaria', 'Maquinaria', 6),
            this.textField('litros', 'Litros', 7, environment.appName !== 'hernandorena'),
            this.textField('superficie_cultivada', 'Superficie', 8, environment.appName === 'hernandorena'),
            this.textField('dosis', 'Dosis', 9, environment.appName === 'hernandorena'),
            this.textField('total_dosis', 'Dosis', 10, environment.appName === 'hernandorena'),
            this.textField('eficacia', 'Eficacia', 11),
            this.switchField('aplicado', 'Aplicado', 12),
        ];

        return this.registerVisibleFields(fields);
    }

    private textField(name: string, label: string, order: number, isVisible = true): FormField<TareaFitoModel> {
        return {
            name,
            label,
            input: {
                type: InputType.ONLY_TEXT,
                isEditable: false,
            },
            width: 3,
            conditions: this.conditions({ isVisible }),
            order,
        };
    }

    private switchField(name: string, label: string, order: number): FormField<TareaFitoModel> {
        return {
            name,
            label,
            input: {
                type: InputType.SWITCH,
                isEditable: false,
            },
            width: 3,
            conditions: this.conditions(),
            order,
        };
    }

    private registerVisibleFields(fields: FormField<TareaFitoModel>[]): FormField<TareaFitoModel>[] {
        for (const field of fields) {
            if (field.conditions.isVisible) {
                this.fieldNames.push(field);
                this.fieldLabels.push(field.label);
            }
        }

        return fields.sort((a, b) => a.order - b.order);
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }
}
